module.exports = __webpack_public_path__ + "static/media/info_clear_2.6bd7e4fd.png";